export enum MarkArea {
  Draw = 'draw',
  LayerFromWorkspace = 'layer_from_workspace',
  SelectLineFeature = 'select_line_feature',
}

export enum MarkAreaDrawingToolType {
  Line = 'line',
  Polygon = 'polygon',
}
